const Card = ({ children }) => (
  <div className=" rounded-lg overflow-hidden flex-col gap-2">
    {children}
  </div>
);
export default Card;
